import { useTranslation } from "react-i18next"

import Button, { type ButtonVariants2 } from "@/components/Button/Button"

interface SaveEditButtonProps {
  currentValues: unknown
  initialValues: unknown
  isLoading: boolean
  save?: () => void
  name?: string
  variant?: ButtonVariants2
}

export default function SaveEditButton({
  currentValues,
  initialValues,
  isLoading,
  save,
  name,
  variant,
}: SaveEditButtonProps) {
  const { t } = useTranslation()
  return (
    <div>
      <Button
        variant={variant}
        type="submit"
        big
        disabled={
          JSON.stringify(currentValues) == JSON.stringify(initialValues)
        }
        isLoading={isLoading}
        onClick={() => {
          save?.()
        }}
      >
        {name || t("buttons.save")}
      </Button>
    </div>
  )
}
